export default __webpack_public_path__ + "static/media/img_step_car06.bd920535.jpg";